'use strict'
/**
 * dayPlan.js — Contrato DayPlan (MACRO 1 · Ola 2).
 *
 * Tipado MINIMAL deliberado: los day_plans son INMUTABLES una vez
 * escritos (ley del proyecto) y su shape interno es del orquestador.
 * Este esquema tipa SOLO lo que las superficies (TODAY, CALENDAR)
 * consumen para render — el resto viaja en passthrough.
 *
 * PRODUCTOR: src/engine/orchestrator.js (buildEnrichedDayPlan) →
 *            tabla day_plans
 * CONSUMIDOR: TodayV2Page, CalendarV2Page/WeekFullViewSheet
 */

const { z } = require('./z')

const DayPlanSchema = z
  .object({
    plan_date: z.string(),                                  // ISO date
    day_type: z.string(),                                   // training | rest | active_recovery…
    status: z.string().nullable().optional(),               // pending | completed | partial | skipped
    workout_title: z.string().nullable().optional(),
    estimated_duration_minutes: z.number().nullable().optional(),
    workout_type: z.string().nullable().optional(),
    nutrition_plan: z.unknown().nullable().optional(),      // shape propio (PLATE-2 / timing_comidas)
    mobility_pre: z.unknown().nullable().optional(),
    mobility_post: z.unknown().nullable().optional(),
    recovery_protocol: z.unknown().nullable().optional(),
    adaptation_reason: z.string().nullable().optional(),
    aria_message: z.string().nullable().optional(),
    metadata: z.record(z.string(), z.unknown()).nullable().optional(),
    vital_load: z.number().nullable().optional(),
  })
  .passthrough()

module.exports = { DayPlanSchema }
